export class UpdateApplication {
  successUrl: string;
  failureUrl: string;
  apiKey: string;
  cyberScoreThreshold: number;
  isEnabled: boolean;
  bypassAuthentication: boolean;
  retriesFailedPeriod: number;
  maxFailedRetriesAttempts: number;
  byPassAppletCheck: boolean;
  byPassApplettGroups: string;
  gracePeriodApplyToAllUsers: boolean;
  appletcheckByPassIpaddress: boolean;
  appletCheckByPassIpaddressList: string;
  updateTimeStamp: boolean;
  enableRemediation: boolean;
  skipAppletCheckAfterInstalling: boolean;
  isGrace4PeriodUpdated: boolean;
  thirdPartyServicesActivated: string;
  isHelpEnabled: boolean;
  maxHelpButtonAttemptsAllowed: number;
  constructor() {}
}
